import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useUpdateCustomPerkMutation = createMutationHook(
  MembershipsCreatorApiClient.updateCustomPerk,
  {
    mutationKey: ['updateCustomPerk'],
  },
)
